import type { BlockSnapshot } from '@blocksuite/store';

export function withMovedCanvasBlockXYWH(
  snapshot: BlockSnapshot,
  xywh: string
): BlockSnapshot {
  return {
    ...snapshot,
    props: {
      ...snapshot.props,
      xywh,
    },
  };
}
